// CoachTeamsSection.jsx
import { useOutletContext } from 'react-router-dom';
import { CoachSidebar } from '../../../components/coach/dashboard/CoachSidebar';
import { TeamDirectory } from './TeamDirectory';

// /coach/teams: the team directory. Picking a team opens its profile at
// /coach/team/:teamId (CoachTeamProfilePage), which has the Roster, Schedule
// and Statistics tabs this page used to show for one team.
export const CoachTeamsSection = () => {
  const { activeView } = useOutletContext();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
      {/* Left Sidebar */}
      <div className="lg:col-span-1 ">
        <CoachSidebar activeView={activeView} />
      </div>

      {/* Right Content Area */}
      <section className="lg:col-span-3 w-full mx-auto">
        <TeamDirectory basePath="/coach" />
      </section>
    </div>
  );
};
